import { Sidebar, SidebarContent, SidebarRail } from "@/components/ui/sidebar";
import { NavGroup } from "@/components/layouts/nav-group";
import { iuqSidebarData } from "./data/iuq-sidebar-data";

export function IUQSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar collapsible="icon" variant="sidebar" {...props}>
      <SidebarContent>
        {iuqSidebarData.navGroups.map((props, index) => (
          <NavGroup key={index} {...props} />
        ))}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  );
}
